export default function CParameters() {
  return <h2>C Parameters</h2>;
}
